import React, { useState, useRef, useEffect } from "react";
import {
  X,
  Plus,
  Minus,
  Phone,
  Building2,
  Users,
  MapPin,
  Globe,
  Calendar,
  Check,
  ArrowRight,
  ArrowLeft,
  Shield,
  UserCheck,
  Eye,
  User,
  FileText,
  CreditCard,
  Clock,
  Mail,
  Headset,
} from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { getApi, postApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import { DialogBox } from "../../components/Elements/DialogBox";
import PopupCard from "./PopupCard";
import { updateUserCompletionStatus } from "../../redux/auth/authSlice";
import CustomSelect from "../../components/Elements/Select/CustomSelect";
const PermissionForm = ({ permissionConClose, onSignup, onResetPassword }) => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [yearType, setYearType] = useState("financial");
  const [showSuccess, setShowSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [step]);

  // Prevent background scrolling when form is open
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const [services, setServices] = useState([]);
  const [projectTypesList, setProjectTypesList] = useState([]);
  const [licenseCosts, setLicenseCosts] = useState({});

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_ALL_PROJECT_TYPES(100),
        });
        if (response.success && response.data?.data) {
          const activeServices = response.data.data.filter(
            (item) => item.status === "Active",
          );
          setProjectTypesList(activeServices);

          const fetchedServices = activeServices.map(
            (item) => item.project_type,
          );
          if (!fetchedServices.includes("Others (specify)")) {
            fetchedServices.push("Others (specify)");
          }
          setServices(fetchedServices);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchLicenseCosts = async () => {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_LICENSE_COST,
        });
        if (response.success && Array.isArray(response.data)) {
          const costsMap = {};
          response.data.forEach((item) => {
            if (item.role && item.price !== undefined) {
              costsMap[item.role] = Number(item.price);
            }
          });
          setLicenseCosts((prev) => ({
            ...prev,
            ...costsMap,
          }));
        }
      } catch (error) {
        console.error("Error fetching license costs:", error);
      }
    };
    fetchLicenseCosts();
  }, []);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [requestId, setRequestId] = useState("");
  // const auth = localStorage.getItem("authToken");
  // console.log(auth, "authtoken")
  const [otherFacilityFields, setOtherFacilityFields] = useState([
    { id: 1, value: "" },
  ]);
  const [otherServicesFields, setOtherServicesFields] = useState([
    { id: 1, value: "" },
  ]);
  const user = useSelector((state) => state?.auth?.user);
  const clientId = user?._id;

  const [formData, setFormData] = useState({
    // organizationName: "",
    // email_id: "",
    contact_no: "",
    industries: [],
    facilityTypes: [],
    reportingPeriod: [],
    organizationSize: "",
    headquarterLocation: "",
    numberOfLocations: "",
    licensesRequired: {
      "Sub admin": { count: "0" },
      "Local Supervisor": { count: "0" },
      User: { count: "0" },
      Employees: { count: "0" },
      Vendors: { count: "0" },
      "Management View": { count: "0" },
      "Group View": { count: "0" },
    },
    hasNetZeroTargets: "",
    netZeroYear: "",
    trackingEmissions: "",
    trackingMethod: "",
    servicesRequired: [],
    numberOfServiceLocations: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "contact_no") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10); // Keep only digits, max 10
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
      return;
    }

    if (type === "checkbox") {
      if (name === "servicesRequired") {
        setFormData((prev) => ({
          ...prev,
          [name]: checked
            ? [...prev[name], value]
            : prev[name].filter((item) => item !== value),
        }));
      } else if (name === "industries") {
        setFormData((prev) => ({
          ...prev,
          industries: checked
            ? [...prev.industries, value]
            : prev.industries.filter((item) => item !== value),
        }));
      } else if (name === "facilityTypes") {
        setFormData((prev) => ({
          ...prev,
          facilityTypes: checked
            ? [...prev.facilityTypes, value]
            : prev.facilityTypes.filter((item) => item !== value),
        }));
      }
    } else if (type === "number") {
      const numValue = Math.max(0, parseInt(value) || 0);
      setFormData((prev) => ({ ...prev, [name]: numValue.toString() }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleLicenseIncrement = (licenseKey) => {
    setFormData((prev) => {
      const currentCount =
        parseInt(prev.licensesRequired[licenseKey]?.count) || 0;
      return {
        ...prev,
        licensesRequired: {
          ...prev.licensesRequired,
          [licenseKey]: { count: (currentCount + 1).toString() },
        },
      };
    });
  };

  const handleLicenseDecrement = (licenseKey) => {
    setFormData((prev) => {
      const currentCount =
        parseInt(prev.licensesRequired[licenseKey]?.count) || 0;
      const newCount = Math.max(0, currentCount - 1);
      return {
        ...prev,
        licensesRequired: {
          ...prev.licensesRequired,
          [licenseKey]: { count: newCount.toString() },
        },
      };
    });
  };

  const addOtherFacilityField = () => {
    setOtherFacilityFields([
      ...otherFacilityFields,
      { id: Date.now(), value: "" },
    ]);
  };

  const removeOtherFacilityField = (id) => {
    if (otherFacilityFields.length > 1) {
      setOtherFacilityFields(
        otherFacilityFields.filter((field) => field.id !== id),
      );
    }
  };

  const handleOtherFacilityChange = (id, value) => {
    setOtherFacilityFields(
      otherFacilityFields.map((field) =>
        field.id === id ? { ...field, value } : field,
      ),
    );
  };

  const addOtherServicesField = () => {
    setOtherServicesFields([
      ...otherServicesFields,
      { id: Date.now(), value: "" },
    ]);
  };

  const removeOtherServicesField = (id) => {
    if (otherServicesFields.length > 1) {
      setOtherServicesFields(
        otherServicesFields.filter((field) => field.id !== id),
      );
    }
  };

  const handleOtherServicesChange = (id, value) => {
    setOtherServicesFields(
      otherServicesFields.map((field) =>
        field.id === id ? { ...field, value } : field,
      ),
    );
  };

  const triggerPopup = (
    type,
    title,
    message,
    onConfirm = null,
    confirmText = "OK",
    duration = 3000,
    onCloseCallback = null,
  ) => {
    setPopupData({
      type,
      title,
      message,
      onConfirm,
      confirmText,
    });
    setShowPopup(true);
    if (!onConfirm) {
      setTimeout(() => {
        setShowPopup(false);
        if (onCloseCallback) onCloseCallback();
      }, duration);
    }
  };

  const handleNext = () => {
    if (
      !formData.contact_no ||
      formData.facilityTypes.length === 0 ||
      !formData.organizationSize ||
      !formData.numberOfLocations ||
      !formData.headquarterLocation ||
      !formData.numberOfServiceLocations ||
      !formData.reportingPeriod ||
      formData.reportingPeriod.length === 0
    ) {
      triggerPopup(
        "error",
        "Error",
        "Please fill all required fields in Step 1",
      );
      return;
    }

    if (formData.contact_no.length !== 10) {
      triggerPopup(
        "error",
        "Error",
        "Contact number must be exactly 10 digits",
      );
      return;
    }

    if (!formData.hasNetZeroTargets || !formData.trackingEmissions) {
      triggerPopup(
        "error",
        "Error",
        "Please answer all sustainability targets questions",
      );
      return;
    }
    if (formData.hasNetZeroTargets === "yes" && !formData.netZeroYear) {
      triggerPopup("error", "Error", "Please specify Net Zero target year");
      return;
    }
    if (formData.trackingEmissions === "yes" && !formData.trackingMethod) {
      triggerPopup(
        "error",
        "Error",
        "Please specify carbon emissions tracking method",
      );
      return;
    }

    setStep(2);
  };

  const handleNextToStep3 = () => {
    if (formData.servicesRequired.length === 0) {
      triggerPopup(
        "error",
        "Error",
        "Please fill all required fields in Step 2",
      );
      return;
    }
    setStep(3);
  };

  const handleNextToStep4 = () => {
    setStep(4);
  };

  const handleNextToStep5 = () => {
    setStep(5);
  };

  const handleStepNext = () => {
    if (step === 1) handleNext();
    else if (step === 2) handleNextToStep3();
    else if (step === 3) handleNextToStep4();
    else if (step === 4) handleNextToStep5();
  };

  const handleSubmit = async () => {
    setError("");
    setIsSubmitting(true);

    try {
      // Prepare industry data
      const industry = formData.facilityTypes.filter(
        (type) => type !== "Others, Please specify",
      );
      const otherIndustry = formData.facilityTypes.includes(
        "Others, Please specify",
      )
        ? otherFacilityFields.map((f) => f.value).filter((v) => v)
        : [];

      // Prepare license data
      const license = {};
      const licenseMapping = {
        "Sub admin": "sub_admin",
        "Local Supervisor": "local_supervisor",
        User: "user",
        Employees: "employee",
        Vendors: "vendor",
        "Management View": "management_view",
        "Group View": "group_view",
      };

      Object.keys(formData.licensesRequired).forEach((key) => {
        if (
          formData.licensesRequired[key] &&
          formData.licensesRequired[key].count
        ) {
          const mappedKey = licenseMapping[key];
          if (mappedKey) {
            license[mappedKey] = {
              total: parseInt(formData.licensesRequired[key].count) || 0,
              price: licenseCosts[key] || 0,
            };
          }
        }
      });

      // Prepare services required with titles and prices
      const servicesRequired = getSelectedServicesWithPrices();

      // Prepare API payload
      const payload = {
        client_id: clientId,
        organizationName: user?.organization?.name || user?.name || "",
        email_id: user?.email || "",
        contact_no: formData.contact_no,
        industry: industry,
        otherIndustry: otherIndustry,
        assessment_period: formData.reportingPeriod,
        organizationSize: parseInt(formData.organizationSize) || 0,
        headquarter_location: formData.headquarterLocation,
        no_of_location: parseInt(formData.numberOfLocations) || 0,
        license: license,
        net_zero_target: {
          hasTarget: formData.hasNetZeroTargets === "yes",
          details:
            formData.hasNetZeroTargets === "yes"
              ? {
                  year: formData.netZeroYear,
                }
              : {},
        },
        carbon_emission_track: {
          hasTarget: formData.trackingEmissions === "yes",
          details:
            formData.trackingEmissions === "yes"
              ? {
                  method: formData.trackingMethod,
                }
              : {},
        },
        services_required: servicesRequired,
        location_opt: parseInt(formData.numberOfServiceLocations) || 0,
        yearType: yearType,
        totalLicenses: totalLicenses,
        servicesSubtotal: servicesSubtotal,
        licensesSubtotal: licensesSubtotal,
        overallSubtotal: overallSubtotal,
        gstAmount: gstAmount,
        totalAmount: totalAmount,
      };

      console.log("Payload to be sent:", payload);

      // Make API call
      // const response = await fetch('http://localhost:8081/api/client/setup/create-form', {
      //   method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      // },
      // body: JSON.stringify(payload)
      // });

      const response = await postApi({
        apiUrl: API_URLS.SETUP_FORM,
        data: payload,
        // headers: {
        //   Authorization: `Bearer ${auth}`, // ✅ send token here
        //   "Content-Type": "application/json",
        // },
      });

      // if (!response.ok) {
      //   const errorData = await response.json();
      //   throw new Error(errorData.message || 'Failed to submit form');
      // }

      if (response.success) {
        const randomNum = Math.floor(1000 + Math.random() * 9000);
        setRequestId(`#REQ-2025-${randomNum}`);
        setIsSubmitted(true);
      } else {
        triggerPopup(
          "error",
          "Error",
          response.message || "Failed to submit form",
        );
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      //setError(err.message || "Failed to submit form. Please try again.");
      triggerPopup(
        "error",
        "Error",
        err.message || "Failed to submit form. Please try again",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const facilityTypes = [
    "Automotive & Auto Components",
    "Chemicals & Petrochemicals",
    "Cement",
    "Steel & Metals",
    "Power & Utilities",
    "Oil & Gas",
    "Logistics & Transportation",
    "Construction & Real Estate",
    "FMCG",
    "Food & Beverage",
    "Pharmaceuticals",
    "Electronics Manufacturing",
    "Textile & Apparel",
    "Waste Management & Recycling",
    "IT & Digital Technology",
    "Banking & Financial Services",
    "Government & Public Sector",
    "Renewable Energy",
    "Mining",
    "Others, Please specify",
  ];

  const licenseDetails = [
    {
      key: "Sub admin",
      title: "Sub admin",
      description: "Full administrative access",
      price: licenseCosts["Sub admin"] ?? 0,
      icon: Shield,
    },
    {
      key: "Local Supervisor",
      title: "Local Supervisor",
      description: "Manage team and approve data",
      price: licenseCosts["Local Supervisor"] ?? 0,
      icon: UserCheck,
    },
    {
      key: "User",
      title: "User",
      description: "Standard user access",
      price: licenseCosts["User"] ?? 0,
      icon: User,
    },
    {
      key: "Employees",
      title: "Employees",
      description: "Data entry and viewing",
      price: licenseCosts["Employees"] ?? 0,
      icon: Users,
    },
    {
      key: "Vendors",
      title: "Vendors",
      description: "Limited vendor access",
      price: licenseCosts["Vendors"] ?? 0,
      icon: Building2,
    },
    {
      key: "Management View",
      title: "Management View",
      description: "Executive dashboard access",
      price: licenseCosts["Management View"] ?? 0,
      icon: Eye,
    },
    {
      key: "Group View",
      title: "Group View",
      description: "Multi-location overview",
      price: licenseCosts["Group View"] ?? 0,
      icon: Globe,
    },
  ];

  const totalLicenses = Object.values(formData.licensesRequired).reduce(
    (sum, lic) => sum + (parseInt(lic?.count) || 0),
    0,
  );

  const servicePrices = {
    "Measure carbon footprint": {
      title: "Carbon Footprint Calculation",
      price: 50000,
    },
    "Reduce emissions": { title: "Emission Reduction Planning", price: 40000 },
    "Offset emissions": { title: "Emission Offsetting", price: 35000 },
    "Generate carbon credits": {
      title: "Carbon Credit Generation",
      price: 60000,
    },
    "Monitor sustainability performance": {
      title: "Sustainability Monitoring",
      price: 45000,
    },
    Audit: { title: "Sustainability Audit", price: 30000 },
    "ESG disclosure & Reporting": {
      title: "ESG Reporting (BRSR)",
      price: 75000,
    },
    "Net Zero Roadmap creation": {
      title: "Net Zero Strategy Roadmap",
      price: 100000,
    },
    "Life Cycle Assessment": { title: "Life Cycle Assessment", price: 80000 },
    "Decarbonization Strategy": {
      title: "Decarbonization Strategy",
      price: 100000,
    },
    "Net Zero Product": { title: "Net Zero Product Design", price: 90000 },
    "SDG Performance": { title: "SDG Performance Tracking", price: 55000 },
    "Others (specify)": { title: "Other Custom Service", price: 0 },
  };

  const getSelectedServicesWithPrices = () => {
    const list = [];
    formData.servicesRequired.forEach((service) => {
      if (service === "Others (specify)") {
        otherServicesFields.forEach((field) => {
          if (field?.value && field.value.trim()) {
            list.push({
              title: field.value.trim(),
              price: 0,
              isCustom: true,
            });
          }
        });
      } else {
        const apiItem = projectTypesList.find(
          (item) => item.project_type === service,
        );
        if (apiItem) {
          list.push({
            title: service,
            price: Number(apiItem.service_cost || 0),
          });
        } else {
          const mapped = servicePrices[service];
          if (mapped) {
            list.push({
              title: mapped.title,
              price: mapped.price,
            });
          } else {
            list.push({
              title: service,
              price: 0,
              isCustom: true,
            });
          }
        }
      }
    });
    return list;
  };

  const selectedServicesList = getSelectedServicesWithPrices();
  const servicesSubtotal = selectedServicesList.reduce(
    (sum, item) => sum + item.price,
    0,
  );

  const selectedLicensesList = licenseDetails
    .map((lic) => {
      const count = parseInt(formData.licensesRequired[lic.key]?.count) || 0;
      return {
        ...lic,
        count,
        totalPrice: count * lic.price,
      };
    })
    .filter((lic) => lic.count > 0);

  const licensesSubtotal = selectedLicensesList.reduce(
    (sum, item) => sum + item.totalPrice,
    0,
  );

  const overallSubtotal = servicesSubtotal + licensesSubtotal;
  const gstAmount = Math.round(overallSubtotal * 0.18);
  const totalAmount = overallSubtotal + gstAmount;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        zIndex: 9999,
      }}
    >
      <div className="bg-white py-6 px-8 rounded-xl shadow-2xl w-[50%] max-w-4xl my-8 relative flex flex-col max-h-[90vh]">
        {/* Close Button */}
        {/* {permissionConClose && (
          <button
            type="button"
            onClick={permissionConClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors p-1 z-20"
          >
            <X className="w-5 h-5" />
          </button>
        )} */}
        {!isSubmitted ? (
          <>
            {error && (
              <div className="mx-0 mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-600 m-0">
                  Please fill all required fields.
                </p>
              </div>
            )}
            {/* Step progress bar */}
            <div className="flex items-center gap-2 mb-6 pr-8">
              <div className="h-1.5 bg-gray-200 rounded-full flex-1 overflow-hidden">
                <div
                  className="h-full bg-[#06513D] transition-all duration-300 rounded-full"
                  style={{ width: `${(step / 5) * 100}%` }}
                />
              </div>
              <span className="text-xs font-semibold text-gray-500 min-w-fit pl-2">
                Step {step} of 5
              </span>
            </div>

            <div
              ref={scrollRef}
              className="flex-1 overflow-y-auto pr-1 mr-4 pb-4"
            >
              {step === 1 && (
                /* Page 1: Organization Information */
                <div className="space-y-6">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      Organization Information
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Tell us about your organization
                    </p>
                  </div>

                  {/* Row 1: Contact Number & Industry */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Contact Number <span className="text-gray-900">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                          <Phone className="w-4 h-4" />
                        </span>
                        <input
                          type="tel"
                          name="contact_no"
                          required
                          value={formData.contact_no}
                          onChange={handleChange}
                          className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] transition-all bg-gray-50/30 text-sm"
                          placeholder="Enter contact number"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Industry or sector you fall in{" "}
                        <span className="text-gray-900">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                          <Building2 className="w-4 h-4" />
                        </span>
                        <select
                          name="facilityTypes"
                          required
                          value={formData.facilityTypes[0] || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFormData({
                              ...formData,
                              facilityTypes: value ? [value] : [],
                            });
                          }}
                          className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] transition-all bg-white text-sm"
                        >
                          <option value="">Select Industry</option>
                          {facilityTypes.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                      {formData.facilityTypes.includes(
                        "Others, Please specify",
                      ) && (
                        <div className="mt-3 space-y-2">
                          {otherFacilityFields.map((field, index) => (
                            <div
                              key={field.id}
                              className="flex items-center gap-2"
                            >
                              <input
                                type="text"
                                value={field.value}
                                onChange={(e) =>
                                  handleOtherFacilityChange(
                                    field.id,
                                    e.target.value,
                                  )
                                }
                                className="flex-1 px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] text-sm"
                                placeholder={`Please specify industry ${index + 1}`}
                              />
                              <button
                                type="button"
                                onClick={() => addOtherFacilityField()}
                                className="p-2 bg-[#06513D] text-white rounded-lg hover:bg-[#054a36]"
                              >
                                <Plus className="w-4 h-4" />
                              </button>
                              {otherFacilityFields.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    removeOtherFacilityField(field.id)
                                  }
                                  className="p-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                                >
                                  <Minus className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Row 2: Organization Size & Number of Locations */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        Organization size (Number of employees){" "}
                        <span className="text-gray-900">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                          <Users className="w-4 h-4" />
                        </span>
                        <input
                          type="number"
                          name="organizationSize"
                          required
                          min="0"
                          value={formData.organizationSize}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (
                              e.key === "-" ||
                              e.key === "e" ||
                              e.key === "E"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] transition-all bg-gray-50/30 text-sm"
                          placeholder="Enter number of employees"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        No. of location <span className="text-gray-900">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                          <MapPin className="w-4 h-4" />
                        </span>
                        <input
                          type="number"
                          name="numberOfLocations"
                          required
                          min="0"
                          value={formData.numberOfLocations}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (
                              e.key === "-" ||
                              e.key === "e" ||
                              e.key === "E"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] transition-all bg-gray-50/30 text-sm"
                          placeholder="Enter number"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Row 3: Headquarter Location & Reporting Period */}
                  {/* Row 3: Headquarter Location & Number of Service Locations */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 md:min-h-[40px]">
                        Headquarter location{" "}
                        <span className="text-gray-900">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                          <Globe className="w-4 h-4" />
                        </span>
                        <input
                          type="text"
                          name="headquarterLocation"
                          required
                          value={formData.headquarterLocation}
                          onChange={handleChange}
                          className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] transition-all bg-gray-50/30 text-sm"
                          placeholder="Enter location"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 md:min-h-[40px]">
                        Number of locations for which you want to opt for
                        services <span className="text-gray-900">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
                          <MapPin className="w-4 h-4" />
                        </span>
                        <input
                          type="number"
                          name="numberOfServiceLocations"
                          required
                          min="0"
                          value={formData.numberOfServiceLocations}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (
                              e.key === "-" ||
                              e.key === "e" ||
                              e.key === "E"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] transition-all bg-gray-50/30 text-sm"
                          placeholder="Enter number of locations"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Reporting Year Type selection */}
                  <div className="space-y-3">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Reporting Year Type{" "}
                      <span className="text-gray-900">*</span>
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Financial Year Card */}
                      <label
                        className={`p-4 border rounded-xl flex items-start gap-3 cursor-pointer transition-all ${
                          yearType === "financial"
                            ? "border-[#06513D] bg-[#06513D]/5"
                            : "border-gray-200 bg-white hover:bg-gray-50"
                        }`}
                      >
                        <input
                          type="radio"
                          name="yearType"
                          checked={yearType === "financial"}
                          onChange={() => {
                            setYearType("financial");
                            setFormData((prev) => ({
                              ...prev,
                              reportingPeriod: [],
                            }));
                          }}
                          className="mt-1 h-4 w-4 text-[#06513D] focus:ring-[#06513D]"
                          style={{ accentColor: "#06513D" }}
                        />
                        <div>
                          <span className="block text-sm font-semibold text-gray-900">
                            Financial Year
                          </span>
                          <span className="block text-xs text-gray-500 mt-0.5">
                            Financial Year
                          </span>
                        </div>
                      </label>

                      {/* Calendar Year Card */}
                      <label
                        className={`p-4 border rounded-xl flex items-start gap-3 cursor-pointer transition-all ${
                          yearType === "calendar"
                            ? "border-[#06513D] bg-[#06513D]/5"
                            : "border-gray-200 bg-white hover:bg-gray-50"
                        }`}
                      >
                        <input
                          type="radio"
                          name="yearType"
                          checked={yearType === "calendar"}
                          onChange={() => {
                            setYearType("calendar");
                            setFormData((prev) => ({
                              ...prev,
                              reportingPeriod: [],
                            }));
                          }}
                          className="mt-1 h-4 w-4 text-[#06513D] focus:ring-[#06513D]"
                          style={{ accentColor: "#06513D" }}
                        />
                        <div>
                          <span className="block text-sm font-semibold text-gray-900">
                            Calendar Year
                          </span>
                          <span className="block text-xs text-gray-500 mt-0.5">
                            Calendar Year
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>

                  {/* Start Year selector */}
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Fiscal Year For Reporting{" "}
                      <span className="text-gray-900">*</span>
                    </label>
                    <div className="relative permission-form-dropdown-wrapper">
                      <style>{`
                        .permission-custom-select .ant-select-selector {
                          border-color: #e5e7eb !important; /* border-gray-200 */
                          border-radius: 0.5rem !important; /* rounded-lg */
                          height: 42px !important;
                          padding-left: 0.5rem !important;
                          display: flex !important;
                          align-items: center !important;
                        }
                        .permission-custom-select .ant-select-selector:focus,
                        .permission-custom-select .ant-select-selector:focus-within {
                          border-color: #06513D !important;
                          box-shadow: 0 0 0 2px rgba(6, 81, 61, 0.2) !important;
                        }
                        .permission-custom-select .ant-select-selection-placeholder {
                          line-height: 40px !important;
                          display: flex !important;
                          align-items: center !important;
                        }
                        /* Custom Checkbox Colors for the dropdown */
                        .permission-form-dropdown-wrapper .ant-checkbox-checked .ant-checkbox-inner {
                          background-color: #06513D !important;
                          border-color: #06513D !important;
                        }
                        .permission-form-dropdown-wrapper .ant-checkbox-wrapper:hover .ant-checkbox-inner,
                        .permission-form-dropdown-wrapper .ant-checkbox:hover .ant-checkbox-inner {
                          border-color: #06513D !important;
                        }
                        /* Make the right-side checkmark green as well */
                        .permission-form-dropdown-wrapper .ant-select-item-option-selected .ant-select-item-option-state {
                          color: #06513D !important;
                        }
                      `}</style>
                      <CustomSelect
                        className="permission-custom-select"
                        mode="multiple"
                        width="100%"
                        height="42px"
                        placeholder="Select year"
                        value={formData.reportingPeriod || []}
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        onChange={(selectedValues) => {
                          setFormData((prev) => ({
                            ...prev,
                            reportingPeriod: selectedValues,
                          }));
                        }}
                        options={
                          yearType === "financial"
                            ? [
                                { label: "2026-2027", value: "2026-2027" },
                                { label: "2025-2026", value: "2025-2026" },
                                { label: "2024-2025", value: "2024-2025" },
                                { label: "2023-2024", value: "2023-2024" },
                                { label: "2022-2023", value: "2022-2023" },
                                { label: "2021-2022", value: "2021-2022" },
                              ]
                            : [
                                { label: "2026", value: "2026" },
                                { label: "2025", value: "2025" },
                                { label: "2024", value: "2024" },
                                { label: "2023", value: "2023" },
                                { label: "2022", value: "2022" },
                                { label: "2021", value: "2021" },
                              ]
                        }
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                    {/* Net Zero targets */}

                    <div className="space-y-3">
                      <label className="block text-sm font-medium text-gray-700 md:min-h-[40px]">
                        Do you have Net Zero or sustainability targets already
                        set?
                      </label>
                      <div className="flex gap-3">
                        <button
                          type="button"
                          onClick={() =>
                            setFormData({
                              ...formData,
                              hasNetZeroTargets: "yes",
                            })
                          }
                          className={`flex-1 py-2 px-4 rounded-lg border text-sm font-medium transition-all text-center ${
                            formData.hasNetZeroTargets === "yes"
                              ? "bg-[#06513D]/5 border-[#06513D] text-[#06513D] font-semibold"
                              : "border-gray-200 text-gray-700 bg-white hover:bg-gray-50"
                          }`}
                        >
                          Yes
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData({
                              ...formData,
                              hasNetZeroTargets: "no",
                              netZeroYear: "",
                            })
                          }
                          className={`flex-1 py-2 px-4 rounded-lg border text-sm font-medium transition-all text-center ${
                            formData.hasNetZeroTargets === "no"
                              ? "bg-[#06513D]/5 border-[#06513D] text-[#06513D] font-semibold"
                              : "border-gray-200 text-gray-700 bg-white hover:bg-gray-50"
                          }`}
                        >
                          No
                        </button>
                      </div>
                      {formData.hasNetZeroTargets === "yes" && (
                        <input
                          type="text"
                          name="netZeroYear"
                          value={formData.netZeroYear}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] text-sm mt-2 bg-white"
                          placeholder="Specify year or goal (e.g., 2030)"
                        />
                      )}
                    </div>

                    {/* Carbon tracking */}
                    <div className="space-y-3">
                      <label className="block text-sm font-medium text-gray-700 md:min-h-[40px]">
                        Are you already tracking your carbon emissions?
                      </label>
                      <div className="flex gap-3">
                        <button
                          type="button"
                          onClick={() =>
                            setFormData({
                              ...formData,
                              trackingEmissions: "yes",
                            })
                          }
                          className={`flex-1 py-2 px-4 rounded-lg border text-sm font-medium transition-all text-center ${
                            formData.trackingEmissions === "yes"
                              ? "bg-[#06513D]/5 border-[#06513D] text-[#06513D] font-semibold"
                              : "border-gray-200 text-gray-700 bg-white hover:bg-gray-50"
                          }`}
                        >
                          Yes
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData({
                              ...formData,
                              trackingEmissions: "no",
                              trackingMethod: "",
                            })
                          }
                          className={`flex-1 py-2 px-4 rounded-lg border text-sm font-medium transition-all text-center ${
                            formData.trackingEmissions === "no"
                              ? "bg-[#06513D]/5 border-[#06513D] text-[#06513D] font-semibold"
                              : "border-gray-200 text-gray-700 bg-white hover:bg-gray-50"
                          }`}
                        >
                          No
                        </button>
                      </div>
                      {formData.trackingEmissions === "yes" && (
                        <input
                          type="text"
                          name="trackingMethod"
                          value={formData.trackingMethod}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] text-sm mt-2 bg-white"
                          placeholder="Specify method or tool used"
                        />
                      )}
                    </div>
                  </div>
                </div>
              )}

              {step === 2 && (
                /* Page 2: Service & Sustainability Details */
                <div className="space-y-6">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      Select Your Sustainability Service
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Choose the sustainability service(s) you want to implement
                      for your organization
                    </p>
                  </div>

                  {/* Sustainability targets and Carbon tracking side-by-side */}

                  {/* Services Required */}
                  <div className="space-y-3">
                    <label className="block text-sm font-semibold text-gray-900 border-b pb-2">
                      Available Services<span className="text-gray-900">*</span>
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {services.map((service) => {
                        const isChecked =
                          formData.servicesRequired.includes(service);
                        return (
                          <label
                            key={service}
                            className={`p-3.5 border rounded-lg flex items-center cursor-pointer select-none transition-all ${
                              isChecked
                                ? "border-[#06513D] bg-[#06513D]/5 text-[#06513D] font-semibold"
                                : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
                            }`}
                          >
                            <input
                              type="checkbox"
                              name="servicesRequired"
                              value={service}
                              checked={isChecked}
                              onChange={handleChange}
                              className="mr-3 h-4 w-4 rounded border-gray-300 text-[#06513D] focus:ring-[#06513D]"
                              style={{ accentColor: "#06513D" }}
                            />
                            <div className="flex justify-between items-start w-full gap-4">
                              <span className="text-sm font-medium text-left">
                                {service}
                              </span>
                              {service !== "Others (specify)" && (
                                <span className="text-xs  font-normal whitespace-nowrap pt-0.5">
                                  {(() => {
                                    const apiItem = projectTypesList.find(
                                      (item) => item.project_type === service,
                                    );
                                    const price = apiItem
                                      ? Number(apiItem.service_cost || 0)
                                      : (servicePrices[service]?.price ?? 0);
                                    return `₹${price.toLocaleString("en-IN")}`;
                                  })()}
                                </span>
                              )}
                            </div>
                          </label>
                        );
                      })}
                    </div>
                    {formData.servicesRequired.includes("Others (specify)") && (
                      <div className="mt-3 space-y-2 w-full md:w-[calc(50%-6px)]">
                        {otherServicesFields.map((field, index) => (
                          <div
                            key={field.id}
                            className="flex items-center gap-2"
                          >
                            <input
                              type="text"
                              value={field.value}
                              onChange={(e) =>
                                handleOtherServicesChange(
                                  field.id,
                                  e.target.value,
                                )
                              }
                              className="flex-1 px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#06513D]/20 focus:border-[#06513D] text-sm"
                              placeholder={`Please specify service ${index + 1}`}
                            />
                            <button
                              type="button"
                              onClick={() => addOtherServicesField()}
                              className="p-2 bg-[#06513D] text-white rounded-lg hover:bg-[#054a36]"
                            >
                              <Plus className="w-4 h-4" />
                            </button>
                            {otherServicesFields.length > 1 && (
                              <button
                                type="button"
                                onClick={() =>
                                  removeOtherServicesField(field.id)
                                }
                                className="p-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                              >
                                <Minus className="w-4 h-4" />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {step === 3 && (
                /* Page 3: License Requirement */
                <div className="space-y-6">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      License Requirement
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Select the number of licenses you need for each user type
                    </p>
                  </div>

                  <div className="space-y-3">
                    {licenseDetails.map(
                      ({ key, title, description, price, icon: Icon }) => (
                        <div
                          key={key}
                          className="flex items-center justify-between p-4 border border-gray-100 rounded-xl hover:shadow-sm transition-all bg-white"
                        >
                          <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-xl bg-[#06513D]/10 flex items-center justify-center text-[#06513D] flex-shrink-0">
                              <Icon className="w-5 h-5" />
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-900 text-sm">
                                {title}
                              </h4>
                              <p className="text-gray-500 text-xs">
                                {description}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-center gap-6">
                            <div className="text-right min-w-[80px]">
                              <div className="font-bold text-gray-900 text-sm">
                                ₹{price}
                              </div>
                              <div className="text-[10px] text-gray-400">
                                per user/month
                              </div>
                            </div>

                            <div className="flex items-center gap-1">
                              <button
                                type="button"
                                onClick={() => handleLicenseDecrement(key)}
                                className="w-8 h-8 rounded border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:border-gray-300 font-semibold"
                              >
                                -
                              </button>
                              <input
                                type="number"
                                min="0"
                                value={
                                  formData.licensesRequired[key]?.count || "0"
                                }
                                onChange={(e) => {
                                  const val = Math.max(
                                    0,
                                    parseInt(e.target.value) || 0,
                                  );
                                  setFormData((prev) => ({
                                    ...prev,
                                    licensesRequired: {
                                      ...prev.licensesRequired,
                                      [key]: { count: val.toString() },
                                    },
                                  }));
                                }}
                                className="w-12 text-center text-sm font-semibold py-1 bg-gray-50 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-[#06513D]"
                              />
                              <button
                                type="button"
                                onClick={() => handleLicenseIncrement(key)}
                                className="w-8 h-8 rounded border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 hover:border-gray-300 font-semibold"
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>
                      ),
                    )}
                  </div>

                  {/* Total Summary */}
                  <div className="flex items-center justify-between p-4 bg-gray-50/60 rounded-xl mt-6">
                    <span className="font-semibold text-gray-700 text-sm">
                      Total Licenses Selected:
                    </span>
                    <span className="text-xl font-bold text-gray-900">
                      {totalLicenses}
                    </span>
                  </div>
                </div>
              )}

              {step === 4 && (
                /* Page 4: Pricing Summary */
                <div className="space-y-6">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      Pricing Summary
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Review your selected services and licenses
                    </p>
                  </div>

                  <div className="border border-gray-100 rounded-2xl p-6 bg-white space-y-6 shadow-sm">
                    {/* Selected Services */}
                    <div className="space-y-3">
                      <div className="flex items-center gap-2 text-[#06513D] font-semibold text-sm border-b pb-2">
                        <FileText className="w-4 h-4" />
                        <span>Selected Services</span>
                      </div>
                      <div className="space-y-2">
                        {selectedServicesList.length > 0 ? (
                          selectedServicesList.map((item, index) => (
                            <div
                              key={index}
                              className="flex justify-between items-center py-2 px-3 bg-gray-50/60 rounded-lg text-sm"
                            >
                              <span className="text-gray-700 font-medium">
                                {item.title}
                              </span>
                              <span className="text-gray-950 font-bold text-right">
                                {item.isCustom ? (
                                  <span className="text-xs text-[#06513D] font-medium">
                                    Cost will be added after service review
                                  </span>
                                ) : (
                                  `₹${item.price.toLocaleString("en-IN")}`
                                )}
                              </span>
                            </div>
                          ))
                        ) : (
                          <p className="text-xs text-gray-400 italic pl-3">
                            No services selected
                          </p>
                        )}
                      </div>
                      <div className="flex justify-between items-center pt-2 text-sm font-semibold border-t border-gray-100">
                        <span className="text-gray-800">Services Subtotal</span>
                        <span className="text-[#06513D]">
                          ₹{servicesSubtotal.toLocaleString("en-IN")}
                        </span>
                      </div>
                    </div>

                    {/* Selected Licenses */}
                    <div className="space-y-3">
                      <div className="flex items-center gap-2 text-[#06513D] font-semibold text-sm border-b pb-2">
                        <Users className="w-4 h-4" />
                        <span>Selected Licenses</span>
                      </div>
                      <div className="space-y-2">
                        {selectedLicensesList.length > 0 ? (
                          selectedLicensesList.map((item, index) => (
                            <div
                              key={index}
                              className="flex justify-between items-center py-2 px-3 bg-gray-50/60 rounded-lg text-sm"
                            >
                              <div className="flex items-baseline gap-2">
                                <span className="text-gray-700 font-medium text-sm">
                                  {item.title}
                                </span>
                                <span className="text-xs text-gray-400">
                                  ({item.count} × ₹
                                  {item.price.toLocaleString("en-IN")})
                                </span>
                              </div>
                              <span className="text-gray-950 font-bold">
                                ₹{item.totalPrice.toLocaleString("en-IN")}
                              </span>
                            </div>
                          ))
                        ) : (
                          <p className="text-xs text-gray-400 italic pl-3">
                            No licenses selected
                          </p>
                        )}
                      </div>
                      <div className="flex justify-between items-center pt-2 text-sm font-semibold border-t border-gray-100">
                        <span className="text-gray-800">Licenses Subtotal</span>
                        <span className="text-[#06513D]">
                          ₹{licensesSubtotal.toLocaleString("en-IN")}
                        </span>
                      </div>
                    </div>

                    {/* Overall Totals */}
                    <div className="border-t pt-4 space-y-2.5">
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-600 font-medium">
                          Subtotal
                        </span>
                        <span className="text-gray-900 font-semibold">
                          ₹{overallSubtotal.toLocaleString("en-IN")}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm">
                        <span className="text-gray-600 font-medium">
                          GST (18%)
                        </span>
                        <span className="text-gray-900 font-semibold">
                          ₹{gstAmount.toLocaleString("en-IN")}
                        </span>
                      </div>
                      <div className="flex justify-between items-center pt-3 border-t text-base font-bold">
                        <span className="text-gray-900">Total Amount</span>
                        <span className="text-[#06513D] text-lg">
                          ₹{totalAmount.toLocaleString("en-IN")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {step === 5 && (
                /* Page 5: Payment & Request Submission */
                <div className="space-y-6">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-1">
                      Payment & Request Submission
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Choose your payment method or submit request for manual
                      processing
                    </p>
                  </div>

                  {/* Gateway integration container */}

                  {/* Manual Processing Box */}
                  <div className="border border-gray-100 rounded-2xl p-5 bg-gray-50/40 text-center space-y-4 shadow-sm">
                    <div>
                      <h4 className="font-bold text-gray-900 text-sm">
                        Submit Request for Manual Processing
                      </h4>
                      <p className="text-xs text-gray-500 mt-1 pl-4 pr-4 text-center">
                        Our team will review your request and contact you within
                        24 hours with payment details and next steps.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                      className="w-[80%] mx-auto py-2.5 px-6 rounded-lg font-semibold text-white bg-[#06513D] hover:bg-[#054a36] focus:ring-2 focus:ring-offset-2 focus:ring-[#06513D] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-sm"
                    >
                      {isSubmitting ? (
                        "Submitting..."
                      ) : (
                        <>
                          <Check className="w-4 h-4" />
                          Submit Request
                        </>
                      )}
                    </button>
                  </div>
                  <div className="flex items-center justify-center gap-3 my-2">
                    <div className="h-px bg-gray-200 flex-1"></div>
                    <span className="text-xs font-bold text-gray-400">OR</span>
                    <div className="h-px bg-gray-200 flex-1"></div>
                  </div>
                  <div className="border border-gray-200 rounded-2xl p-6 bg-white text-center space-y-5 shadow-sm">
                    <div className="flex flex-col items-center space-y-2">
                      <div className="w-12 h-12 rounded-full bg-[#06513D]/10 flex items-center justify-center text-[#06513D]">
                        <Calendar className="w-6 h-6" />
                      </div>
                      <span className="inline-block bg-[#E6EEEC] text-[#06513D] text-[10px] font-bold px-3 py-0.5 rounded-full border border-[#06513D]/20 uppercase tracking-wide">
                        Coming Soon
                      </span>
                    </div>
                    <div className="space-y-1">
                      <h4 className="font-bold text-gray-900 text-base">
                        Payment Gateway Integration Coming Soon!
                      </h4>
                      <p className="text-xs text-gray-500 max-w-lg mx-auto leading-relaxed">
                        We are working on bringing you a seamless and secure
                        payment experience.
                        <br />
                        Stay tuned – it will be available shortly.
                      </p>
                    </div>

                    {/* Payment option tabs */}
                    <div className="grid grid-cols-3 gap-3 pt-2">
                      <div className="flex flex-col items-center justify-between p-4 border border-gray-100 rounded-xl bg-gray-50/20">
                        <div className="flex items-center gap-2 text-gray-400 font-semibold text-xs">
                          <CreditCard className="w-4 h-4 text-gray-400" />
                          <span>Card Payment</span>
                        </div>
                        <span className="mt-3 text-[9px] font-bold text-gray-400 bg-gray-100 px-2.5 py-0.5 rounded-full">
                          Coming Soon
                        </span>
                      </div>
                      <div className="flex flex-col items-center justify-between p-4 border border-gray-100 rounded-xl bg-gray-50/20">
                        <div className="flex items-center gap-2 text-gray-400 font-semibold text-xs">
                          <Building2 className="w-4 h-4 text-gray-400" />
                          <span>Net Banking</span>
                        </div>
                        <span className="mt-3 text-[9px] font-bold text-gray-400 bg-gray-100 px-2.5 py-0.5 rounded-full">
                          Coming Soon
                        </span>
                      </div>
                      <div className="flex flex-col items-center justify-between p-4 border border-gray-100 rounded-xl bg-gray-50/20">
                        <div className="flex items-center gap-2 text-gray-400 font-semibold text-xs">
                          <Globe className="w-4 h-4 text-gray-400" />
                          <span>UPI</span>
                        </div>
                        <span className="mt-3 text-[9px] font-bold text-gray-400 bg-gray-100 px-2.5 py-0.5 rounded-full">
                          Coming Soon
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* Back to Pricing button at the bottom of step 5 */}
                  <div className="pt-4 flex justify-center">
                    <button
                      type="button"
                      onClick={() => setStep(4)}
                      className="w-full py-2 border border-gray-200 text-gray-700 bg-white hover:bg-gray-50 rounded-xl font-medium transition-colors focus:outline-none flex items-center justify-center gap-2 text-xs"
                    >
                      <ArrowLeft className="w-4 h-4" />
                      Back to Pricing
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Footer controls */}
            {step < 5 && (
              <div className="pt-6 border-t mt-4 flex justify-between items-center gap-4">
                {step > 1 && (
                  <button
                    type="button"
                    onClick={() => setStep(step - 1)}
                    className="px-6 py-2 border border-gray-200 text-gray-700 bg-white hover:bg-gray-50 rounded-lg font-medium transition-colors focus:outline-none flex items-center gap-2 text-sm"
                  >
                    <ArrowLeft className="w-4 h-4" />
                    Back
                  </button>
                )}
                <button
                  type="button"
                  onClick={handleStepNext}
                  disabled={isSubmitting}
                  className={`py-2 px-8 rounded-lg font-medium text-white transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-sm bg-[#06513D] hover:bg-[#054a36] focus:ring-[#06513D] ${
                    step === 1 ? "ml-auto" : ""
                  }`}
                >
                  {step === 4 ? (
                    <>
                      Next
                      <ArrowRight className="w-4 h-4" />
                    </>
                  ) : (
                    <>
                      Next
                      <ArrowRight className="w-4 h-4" />
                    </>
                  )}
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="flex-1 overflow-y-auto pr-1 mr-4 flex flex-col items-center py-4">
            {/* Checked Circle */}
            <div
              className="bg-[#EAF6ED] rounded-full flex items-center justify-center mb-6 flex-shrink-0"
              style={{
                width: "80px",
                height: "80px",
                minWidth: "80px",
                minHeight: "80px",
              }}
            >
              <div
                className="rounded-full border-[3px] border-[#2E7D32] flex items-center justify-center text-[#2E7D32] flex-shrink-0"
                style={{
                  width: "48px",
                  height: "48px",
                  minWidth: "48px",
                  minHeight: "48px",
                }}
              >
                <Check className="w-6 h-6" strokeWidth={4} />
              </div>
            </div>

            {/* Title */}
            <h3 className="text-xl font-bold text-gray-900 mb-2 text-center tracking-tight">
              Request Submitted Successfully!
            </h3>

            {/* Subtext */}
            <p className="text-gray-500 text-sm max-w-lg mx-auto text-center mb-8 leading-relaxed">
              Thank you for choosing CARBURN. Your request has been received
              successfully. Our team will review your submission and share the
              quotation, including pricing for any custom services, via email.
            </p>

            {/* Three Info Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 w-full mb-8">
              {/* Card 1: Response Time */}
              <div className="bg-[#06513D]/5 p-5 rounded-2xl flex flex-col items-center text-center border border-[#06513D]/10 shadow-sm transition-all hover:shadow-md">
                <Clock className="w-7 h-7 text-[#06513D] mb-3" />
                <span className="font-bold text-gray-900 text-sm">
                  Response Time
                </span>
                <span className="text-xs text-gray-500 mt-1">
                  Within 24 hours
                </span>
              </div>

              {/* Card 2: Email Notification */}
              <div className="bg-[#06513D]/5 p-5 rounded-2xl flex flex-col items-center text-center border border-[#06513D]/10 shadow-sm transition-all hover:shadow-md">
                <Mail className="w-7 h-7 text-[#06513D] mb-3" />
                <span className="font-bold text-gray-900 text-sm">
                  Email Notification
                </span>
                <span className="text-xs text-gray-500 mt-1">
                  Quotation & update will be sent via email
                </span>
              </div>

              {/* Card 3: Support */}
              <div className="bg-[#06513D]/5 p-5 rounded-2xl flex flex-col items-center border border-[#06513D]/10 shadow-sm transition-all hover:shadow-md">
                <Headset className="w-8 h-8 text-[#06513D] mb-3" />
                <span className="font-bold text-gray-900 text-base mb-4">
                  Support
                </span>
                <div className="flex flex-col gap-2.5">
                  <div className="flex items-center gap-3">
                    <Phone
                      className="w-5 h-5 text-[#06513D]"
                      strokeWidth={2.5}
                      fill="currentColor"
                    />
                    <span className="text-sm font-medium text-[#06513D]">
                      1800 572 2929
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail
                      className="w-5 h-5 text-[#06513D]"
                      strokeWidth={2.5}
                    />
                    <span className="text-sm font-medium text-[#000000]">
                      carburn@offsetgo.earth
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* What happens next box */}
            {/* <div className="bg-[#06513D]/5 border border-[#06513D]/10 rounded-2xl p-6 w-full text-left mb-8 shadow-sm">
              <h4 className="font-bold text-gray-900 text-base mb-4 tracking-wide">
                What happens next?
              </h4>
              <div className="space-y-3.5 text-sm text-gray-600">
                <div className="flex gap-3 items-start">
                  <span className="font-bold text-gray-400 min-w-[18px]">
                    1.
                  </span>
                  <span>
                    Our team will review your requirements and selected services
                  </span>
                </div>
                <div className="flex gap-3 items-start">
                  <span className="font-bold text-gray-400 min-w-[18px]">
                    2.
                  </span>
                  <span>
                    You'll receive a detailed quotation and payment link via
                    email
                  </span>
                </div>
                <div className="flex gap-3 items-start">
                  <span className="font-bold text-gray-400 min-w-[18px]">
                    3.
                  </span>
                  <span>
                    Upon payment confirmation, your account will be activated
                  </span>
                </div>
                <div className="flex gap-3 items-start">
                  <span className="font-bold text-gray-400 min-w-[18px]">
                    4.
                  </span>
                  <span>You'll get access to the Customer Admin Dashboard</span>
                </div>
              </div>
            </div> */}

            {/* Go to Dashboard button */}
            <button
              type="button"
              onClick={() => {
                dispatch(updateUserCompletionStatus(true));
                if (permissionConClose) permissionConClose();
              }}
              className="w-full py-3.5 px-6 rounded-xl font-bold text-white bg-[#06513D] hover:bg-[#054a36] active:scale-[0.99] transition-all text-center text-sm shadow-md cursor-pointer mb-2"
            >
              Go to Dashboard
            </button>

            {/* Request ID */}
          </div>
        )}
      </div>

      {/* {showSuccess && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg p-8 shadow-xl text-center max-w-md">
            <div className="bg-[#06513D] p-3 rounded-full mx-auto w-fit mb-4">
              <svg
                className="w-12 h-12 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-[#06513D] mb-2">
              Registration Successful!
            </h3>
            <p className="text-gray-600">
              Thank you for registering with CARBURN
            </p>
          </div>
        </div>
      )} */}

      {showPopup && (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
            onConfirm={popupData.onConfirm}
            confirmText={popupData.confirmText}
          />
        </div>
      )}
    </div>
  );
};

export default PermissionForm;
